module.exports = __webpack_public_path__ + "img/统一易用的报表中心@2x.6c38ebb1.png";